// extracted by mini-css-extract-plugin
export default {"content_box":"Sec02_content_box__Sy44e","content_box02":"Sec02_content_box02__K4GK3","img_box":"Sec02_img_box__1wf1p","txt_box":"Sec02_txt_box__DnZMa"};